<section class="content-header">
  <div #homePanel class="container-fluid home-panel">
    <div class="card home-container">
      <div class="card-body row">
        <div
          class="home-data-panel"
          (mouseleave)="homeGlobalEntities ? highlightMapEntity() : null"
        >
          @if (homeGlobalEntities) {
            <div class="home-entity-data-container">
              <div class="home-entity-legend">
                <table>
                  <tr>
                    <th>
                      <i
                        class="fas fa-tachometer-alt"
                        [style]="{ color: currentColors[THEME_COLORS.BLACK] }"
                      ></i>
                      <span>{{ "device" | translate }}</span>
                    </th>
                    <th>
                      <i
                        class="fas fa-circle-nodes"
                        [style]="{ color: currentColors[THEME_COLORS.BLUE] }"
                      ></i>
                      <span>{{ "readings" | translate }}</span>
                    </th>
                    <th>
                      <i
                        class="fas fa-check"
                        [style]="{ color: currentColors[THEME_COLORS.GREEN] }"
                      ></i>
                      <span>{{ "in-network" | translate }}</span>
                    </th>
                    <th class="home-entity-no-comm">
                      <i
                        class="fas fa-xmark"
                        [style]="{ color: currentColors[THEME_COLORS.RED] }"
                      ></i>
                      <span>{{ "no-communicates" | translate }}</span>
                    </th>
                  </tr>
                </table>
              </div>
              @for (entity of homeGlobalEntities; track entity; let i = $index) {
                <div
                  id="{{ 'entity' + entity.id }}"
                  class="home-entity-data pointer"
                  [ngClass]="{ 'home-entity-data-inactive': !entity.show }"
                  (click)="goToEntity(entity)"
                  (mouseenter)="highlightMapEntity(entity)"
                >
                  <div class="home-entity-data-title">
                    <span [ngStyle]="{ background: RANDOM_COLORS[i] }">
                      {{ entity.entity.toUpperCase() }}
                    </span>
                  </div>
                  <table class="home-entity-table">
                    @if (
                      !entity.stateValues.lwMeters &&
                      !entity.stateValues.mbusMeters &&
                      !entity.stateValues.lorawanMbus &&
                      !entity.stateValues.gateways
                    ) {
                      <tr>
                        <th>{{ "without-devices" | translate }}</th>
                      </tr>
                    }
                    <!-- LW -->
                    @if (entity.stateValues.lwMeters > 0) {
                      <tr>
                        <th>{{ "meters-lw" | translate }}</th>
                        <td [style]="{ color: currentColors[THEME_COLORS.BLUE] }">
                          {{
                            formatNumber(
                              (entity.stateValues.lwNetworkCommunicationMeters /
                                entity.stateValues.lwMeters) *
                                100,
                              numberFormat,
                              "1.0-2"
                            )
                          }}%
                        </td>
                        <td [style]="{ color: currentColors[THEME_COLORS.GREEN] }">
                          {{
                            formatNumber(
                              entity.stateValues.lwNetworkCommunicationMeters,
                              numberFormat
                            )
                          }}
                        </td>
                        <td [style]="{ color: currentColors[THEME_COLORS.RED] }">
                          <div class="home-entity-pending">
                            {{
                              formatNumber(
                                entity.stateValues.lwNoCommMeters +
                                  entity.stateValues.lwNoNetworkMeters,
                                numberFormat
                              )
                            }}
                            @if (entity.stateValues.lwNoNetworkMeters > 0) {
                              <span [style]="{ color: currentColors[THEME_COLORS.PURPLE] }">
                                <i class="fas fa-hourglass-half"></i>
                                {{
                                  formatNumber(entity.stateValues.lwNoNetworkMeters, numberFormat)
                                }}
                              </span>
                            }
                          </div>
                        </td>
                      </tr>
                    }
                    <!-- MBUS -->
                    @if (entity.stateValues.mbusMeters > 0) {
                      <tr>
                        <th>{{ "meters-mbus" | translate }}</th>
                        <td [style]="{ color: currentColors[THEME_COLORS.BLUE] }">
                          {{
                            formatNumber(
                              (entity.stateValues.mbusNetworkCommunicateMeters /
                                entity.stateValues.mbusMeters) *
                                100,
                              numberFormat,
                              "1.0-2"
                            )
                          }}%
                        </td>
                        <td [style]="{ color: currentColors[THEME_COLORS.GREEN] }">
                          {{
                            formatNumber(
                              entity.stateValues.mbusNetworkCommunicateMeters,
                              numberFormat
                            )
                          }}
                        </td>
                        <td [style]="{ color: currentColors[THEME_COLORS.RED] }">
                          {{
                            formatNumber(entity.stateValues.mbusNoCommNoNetworkMeters, numberFormat)
                          }}
                        </td>
                      </tr>
                    }
                    <!-- Concentrators -->
                    @if (entity.stateValues.lorawanMbus > 0) {
                      <tr>
                        <th>{{ "concentrators" | translate }}</th>
                        <td [style]="{ color: currentColors[THEME_COLORS.BLUE] }">
                          {{
                            formatNumber(
                              (entity.stateValues.networkLorawanMbus /
                                entity.stateValues.lorawanMbus) *
                                100,
                              numberFormat,
                              "1.0-2"
                            )
                          }}%
                        </td>
                        <td [style]="{ color: currentColors[THEME_COLORS.GREEN] }">
                          {{ formatNumber(entity.stateValues.networkLorawanMbus, numberFormat) }}
                        </td>
                        <td [style]="{ color: currentColors[THEME_COLORS.RED] }">
                          {{
                            formatNumber(entity.stateValues.noCommunicateLorawanMbus, numberFormat)
                          }}
                        </td>
                      </tr>
                    }
                    <!-- Gateways -->
                    @if (entity.stateValues.gateways > 0) {
                      <tr>
                        <th>{{ "gateways" | translate }}</th>
                        <td [style]="{ color: currentColors[THEME_COLORS.BLUE] }">
                          {{
                            formatNumber(
                              (entity.stateValues.networkGateways / entity.stateValues.gateways) *
                                100,
                              numberFormat,
                              "1.0-2"
                            )
                          }}%
                        </td>
                        <td [style]="{ color: currentColors[THEME_COLORS.GREEN] }">
                          {{ formatNumber(entity.stateValues.networkGateways, numberFormat) }}
                        </td>
                        <td [style]="{ color: currentColors[THEME_COLORS.RED] }">
                          {{ formatNumber(entity.stateValues.noCommunicateGateways, numberFormat) }}
                        </td>
                      </tr>
                    }
                  </table>
                </div>
              }
            </div>
          } @else {
            <ng-template [ngTemplateOutlet]="elseBlock"></ng-template>
          }
        </div>

        <!-- Entity map -->
        <div class="home-map-container" #mapContainer>
          @if (mapHeight && homeGlobalEntities) {
            <app-map-controller
              [mapHeight]="mapHeight"
              [mapType]="mapType"
              [hideMenu]="true"
              [disableMeasure]="true"
              [disableLegend]="true"
              (homeGlobalEntityHover)="highlightTableEntity($event)"
              [homeGlobalEntities]="homeGlobalEntities"
              [freeDrawEnabled]="true"
              [gatewaysData]="[]"
              [metersData]="[]"
            ></app-map-controller>
          } @else {
            <ng-template [ngTemplateOutlet]="elseBlock"></ng-template>
          }
        </div>
      </div>
    </div>
  </div>
</section>
